<template>
  <dialog class="dialog" open>
    <div class="notification">
      <div class="notificationHeader">
        <div class="textTitle">
          {{ $t('notificationTitle') }}
        </div>
        <div class="right">
          <button class="closeDialogButton">
            <BaseIcon
              name="closeButton-yellow"
              class="closeButton-mini"
              @click="$emit('closeDialogBox')"
            />
          </button>
        </div>
      </div>

      <div class="lineSeparator"></div>
      <div class="messageContainer">
        <Loading v-if="loading" />
        <div v-else>
          <div class="contentMessages">
            <div
              class="list"
              v-for="item in notificationMessageList"
              :key="item.notificationId"
            >
              <notificationMessages :messageDetails="item" />
            </div>
          </div>
        </div>
      </div>
      <div class="lineSeparator"></div>
      <div class="child-componets">
        <button class="close-btn" @click="$emit('closeDialogBox')">
          {{ $t('close') }}
        </button>
      </div>
    </div>
  </dialog>
</template>
<script>
import notificationMessages from './notificationMessages.vue';
import Loading from '@/rex-components/rex-loading.vue';

export default {
  name: 'dialogBoxNotification',
  components: {
    notificationMessages,
    Loading
  },
  props: {
    notificationMessageList: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog {
  @include dropshadow-effect;
  width: 25rem;
  height: 23rem;
  padding: 0.688rem 0.656rem 0.706rem 0.688rem;
  border: solid 0.0063rem #2a2b34;
  background-color: #3c3d40;
  z-index: 1;
  margin-right: 0.9rem;
  border-radius: 0.25rem;
}

.notfication {
  border: #3c3d40;
  display: flex;
}

.lineSeparator {
  margin-top: 0.438rem;
  border: 0.0625rem solid#cecece;
  width: 23.125rem;
}

.textTitle {
  width: 0.563rem;
  height: 0.125rem;
  font-weight: bold;
  color: $color-white;
  margin-left: 0.5rem;
}

.content-text {
  color: antiquewhite;
}

.closeDialogButton {
  margin-left: 21.5rem;
  background-color: transparent;
  border: transparent;
  color: #f59600;
}

.close-btn {
  background: transparent;
  color: #f59600;
  border: transparent;
  margin-left: 0.375rem;
}

.contentMessages {
  @include flex-center-justify(flex-start);
  overflow-y: scroll;
  overflow-x: hidden;
  flex-direction: column;
  width: 23rem;
}

.child-componets {
  @include flex-row-wrap;
  margin-top: 0.438rem;
}

.notificationHeader {
  margin-bottom: 0.438rem;
}

.list {
  margin-top: 0.438rem;
}

.messageContainer {
  height: 16.625rem;
}
.no-data-container {
  height: 16.625rem;
}
</style>
